import React, { useState } from "react";
import { motion } from "framer-motion";
import { work } from "../mock";

export default function Work() {
  const [active, setActive] = useState(null);

  return (
    <section id="work" className="relative border-t border-white/5 py-28 md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="flex items-end justify-between">
          <div>
            <span className="font-display text-xs uppercase tracking-[0.3em] text-[#d4ff4e]">(Work)</span>
            <h2 className="font-display mt-6 text-4xl font-medium md:text-6xl">Selected Work</h2>
          </div>
          <span className="hidden text-sm text-[#8a8a86] md:block">{work.length} projects</span>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-2">
          {work.map((p, i) => (
            <motion.a
              key={p.id}
              href="#contact"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.1 }}
              onMouseEnter={() => setActive(p.id)}
              onMouseLeave={() => setActive(null)}
              data-hover
              className="group relative flex aspect-[4/3] flex-col justify-between overflow-hidden rounded-2xl border border-white/10 p-8"
            >
              {/* Product preview image */}
              <img
                src={p.img}
                alt={p.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-70 grayscale-[0.2] transition-all duration-700 group-hover:scale-105 group-hover:opacity-90 group-hover:grayscale-0"
              />
              {/* Readability + color overlays */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0b] via-[#0a0a0b]/50 to-transparent" />
              <div
                className="absolute inset-0 opacity-40 mix-blend-soft-light transition-opacity duration-700 group-hover:opacity-70"
                style={{ background: `radial-gradient(120% 120% at 30% 15%, ${p.color} 0%, transparent 55%)` }}
              />
              <div className="relative flex items-center justify-between">
                <span className="font-display text-sm text-white/80">0{i + 1}</span>
                <span
                  className="h-3 w-3 rounded-full transition-transform duration-500 group-hover:scale-150"
                  style={{ background: p.color }}
                />
              </div>
              <div className="relative">
                <h3
                  className="font-display text-4xl font-bold text-white transition-transform duration-500 group-hover:-translate-y-1 md:text-6xl"
                >
                  {p.title}
                </h3>
                <p className="mt-3 text-sm text-[#c9c9c4]">{p.cat}</p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
